import { StyleSheet } from 'react-native';

// Same palette the sibling card styles declare locally, so a race card cannot drift in colour.
const C = {
  textDefault: '#F7FAFC',
  textDim: '#9CA3AF',
} as const;

/**
 * Identity block for a FIELD fixture's card (specs/formula-one-challenges).
 *
 * Mirrors `GameInlineCard.styles.ts`'s `teamsColumn` metrics — same flex, same font size — so a
 * race card sits at the same height as the football and basketball cards beside it in the list.
 * A field fixture differing in content must not also differ in rhythm.
 */
export const getRaceCardIdentityStyles = () =>
  StyleSheet.create({
    column: {
      flex: 1,
      gap: 2,
      minWidth: 0,
    },
    titleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
    },
    eventName: {
      fontSize: 11,
      fontWeight: '700' as const,
      color: C.textDefault,
      flex: 1,
    },
    circuit: {
      fontSize: 10,
      fontWeight: '500' as const,
      color: C.textDim,
      // Clears the icon in the row above, so the circuit reads as a caption under the event name.
      paddingLeft: 24,
    },
  });
